<template>
  <a-modal :visible="visible" title="导出报表">
    <div class="flex justify-center px-6 my-4">
      <div class="flex-grow">
        <span> 选择导出时间区间 :</span>
        <div class="mt-3">
          <a-range-picker
            class="w-96"
            v-model="timerange"
            valueFormat="YYYY-MM-DD"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <a-button key="back" @click="$emit('cancel')">取消</a-button>
      <a-button key="submit" type="primary" @click="submit">提交</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      timerange: [],
    };
  },
  watch: {
    visible(a) {
      if (a) {
        this.timerange = [];
      }
    },
  },
  methods: {
    submit() {
      if (this.timerange.length > 0) {
        this.$emit('ok', this.timerange);
        this.$emit('cancel');
      } else {
        this.$message.warning('请选择导出时间');
      }
    },
  },
};
</script>
